var render = function (_h, _vm) {
  var _c = _vm._c
  return _c("div", { staticClass: "helper" }, [
    _c("img", { attrs: { src: "/images/icon.questionmark.svg" } }),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.props.text))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }